import './App.css';
import {Navigate, Route, Routes, useNavigate} from "react-router-dom";
import Login from "./Login/login";
import React from "react";
import {ToastContainerComponent} from './common/Toast';
import "react-toastify/dist/ReactToastify.css"
import VCard from "./Profile/V-card";
import {handleClose} from "./WebSocket/LogOutEvent";
import globalRouter from "./globalRouter";

function App() {
    const navigate = useNavigate();
    globalRouter.navigate = navigate;
    const handleSignOut = () => {
        const storedAccessToken = localStorage.getItem('accessToken');
        fetch(`${process.env.REACT_APP_BASE_URL}/auth/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${storedAccessToken}`,
            },
            body: JSON.stringify({refresh_token: storedAccessToken}), // Pass the access token in the request body
        })
            .then(response => {
                localStorage.removeItem("accessToken");
                localStorage.setItem("loggedIn", true);
                localStorage.setItem('QA', "logOut");
                navigate("/");
                handleClose()
            })
            .catch(error => {
                // handle the error here if needed
            });
    };

    return (
        <div className="App bg-[#F6F6F6] fullHeight">
            <Routes>
                {localStorage.getItem('QA') === "active" ? (
                    <Route path="/" element={<Navigate to="/card" replace/>}/>
                ) : (
                    <Route path="/" element={<Login/>}/>
                )}
                <Route path='/card/:id' element={<VCard/>}/>
                <Route path='/card' element={<VCard handleSignOut={handleSignOut}/>}/>
            </Routes>
            <ToastContainerComponent/>
        </div>

    );
}

export default App;
